/* @flow */
export const getApiHost=()=>{
    let host:string = window.location.hostname;
    
    if (host == 'localhost'){
        return 'http://localhost:8899';
    } else {
        return 'https://phoenix.swarmcolony.com';
    }
}

export const getPhoenixApiGwHost=()=>{
    let host:string = window.location.hostname;

    if (host == 'localhost'){
        return 'https://test-api.gigsdata.com'
    }else {
        return 'https://api.gigsdata.com'
    }
}


// WEBPACK FOOTER //
// ./src/apiUtils/apiHost.js